import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { useInputSize } from '../../../internal/hooks';
import { getInputAdornmentStyles } from '../../styles';
import * as buttonStyles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Прозрачная кнопка с отступами для использования в качестве декорации инпута
 */
export var InputAdornmentButton = /*#__PURE__*/React.forwardRef(function InputAdornmentButton(props, ref) {
  var size = useInputSize();
  var styles = getInputAdornmentStyles(size);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    type: "button"
  }, props), {}, {
    ref: ref,
    className: cx(styles['input-adornment'], buttonStyles['button'])
  }));
});